import type { SVGProps } from "react";

const SolarShieldCheckLinear = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
            <path d="M12 2L3 6v6c0 5 6 9 9 10 3-1 9-5 9-10V6l-9-4Z" />
            <path d="m8.5 12 2.5 2.5 4.5-5" />
        </g>
    </svg>
);

export default SolarShieldCheckLinear;
